"use client";

import { createPlatePlugin } from "platejs/react";

import { FixedToolbar } from "../../ui/fixed-toolbar";
import { FixedToolbarButtons } from "../../ui/custom-fixed-toolbar-buttons";

export const FixedToolbarKit = [
  createPlatePlugin({
    key: "fixed-toolbar",
    render: {
      beforeEditable: () => (
        <FixedToolbar includeFullscreen>
          <FixedToolbarButtons includeFullscreen onFullscreenChange={undefined} isFullscreen={false} pluginConfig={{}} />
        </FixedToolbar>
      ),
    },
  }),
];
